MealModel.$inject = ["$modelFactory", "$http", "$q", "$cacheFactory", "$rootScope", "ApiHttp", "gplansConf", "UserService", "MealItemModel", "RecipeModel", "ImageModel", "LoggedMealModel", "LoggedMealItemModel", "MiscModel", "MeasurementSystem", "ApiFirebase", "Snackbar"];function _typeof(obj) {if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {_typeof = function _typeof(obj) {return typeof obj;};} else {_typeof = function _typeof(obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};}return _typeof(obj);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _slicedToArray(arr, i) {return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();}function _nonIterableRest() {throw new TypeError("Invalid attempt to destructure non-iterable instance");}function _iterableToArrayLimit(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"] != null) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}function _arrayWithHoles(arr) {if (Array.isArray(arr)) return arr;}function _toConsumableArray(arr) {return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();}function _nonIterableSpread() {throw new TypeError("Invalid attempt to spread non-iterable instance");}function _iterableToArray(iter) {if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);}function _arrayWithoutHoles(arr) {if (Array.isArray(arr)) {for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {arr2[i] = arr[i];}return arr2;}}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i] != null ? arguments[i] : {};var ownKeys = Object.keys(source);if (typeof Object.getOwnPropertySymbols === 'function') {ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {return Object.getOwnPropertyDescriptor(source, sym).enumerable;}));}ownKeys.forEach(function (key) {_defineProperty(target, key, source[key]);});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}function _possibleConstructorReturn(self, call) {if (call && (_typeof(call) === "object" || typeof call === "function")) {return call;}return _assertThisInitialized(self);}function _assertThisInitialized(self) {if (self === void 0) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function");}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}import { toFloat } from "../../shared/helpers/to-float";

export var mealDefaults = {
  id: 0,
  calories: "", // "0.00"
  fats: "", // "0.00"
  proteins: "", // "0.00"
  carbohydrates: "", // "0.00"
  skipped: null,
  logged: null,
  logged_meal_id: 0,
  logged_meal_items: [/* LoggedMealItem */],
  logged_meal_calories: 0,
  recipe: null, /* RecipeModel */
  image: null, /* ImageModel */
  meal_number: 0,
  week_number: 0,
  day_number: 0,
  label: "",
  meal_plan: 0,
  meal_items: [/* MealItemModel */],

  recipeMode: false,
  tip: null, // TipModel
  customMeal: null };


var calculatableMealProps = [
'calories',
'proteins',
'fats',
'carbohydrates'];


export function MealModel(
$modelFactory,
$http,
$q,
$cacheFactory,
$rootScope,
ApiHttp,
gplansConf,
UserService,
MealItemModel,
RecipeModel,
ImageModel,
LoggedMealModel,
LoggedMealItemModel,
MiscModel,
MeasurementSystem,
ApiFirebase,
Snackbar)
{
  "ngInject";var


  Meal = /*#__PURE__*/function (_$modelFactory) {_inherits(Meal, _$modelFactory);function Meal() {_classCallCheck(this, Meal);return _possibleConstructorReturn(this, (Meal.__proto__ || Object.getPrototypeOf(Meal)).apply(this, arguments));}_createClass(Meal, [{ key: "track", value: function track()








































































































      {
        return Meal.track(this);
      } }, { key: "untrack", value: function untrack()

      {
        return Meal.untrack(this);
      } }, { key: "skip", value: function skip()

      {
        return Meal.skip(this);
      }

      /**
         * @returns {string[]} array of unique categories from 'meal_items'
         */ }, { key: "getCategories", value: function getCategories()
      {
        return Array.from(new Set(this.meal_items.map(function (m) {return m.category;})));
      } }, { key: "calculatePercentage", value: function calculatePercentage(

      mealItemProp) {
        if (!calculatableMealProps.includes(mealItemProp)) {
          console.warn('wrong mealItemProp', mealItemProp);
          return;
        }
        var plan = this.calculatePlan(mealItemProp);
        var fact = this.calculateFact(mealItemProp);
        return parseFloat(
        (plan === 0 ? 100 : fact / plan * 100).toFixed(0));

      } }, { key: "calculatePlan", value: function calculatePlan(

      mealItemProp) {
        return parseFloat(
        (this.meal_items || []).reduce(function (res, mealItem, i, arr) {
          return res + (parseFloat(mealItem[mealItemProp]) || 0);
        }, 0).toFixed(2));

      } }, { key: "calculateFact", value: function calculateFact(

      mealItemProp) {
        return parseFloat(
        (this.logged_meal_items || []).reduce(function (res, mealItem, i, arr) {
          return res + (parseFloat(mealItem[mealItemProp]) || 0);
        }, 0).toFixed(2));

      } }, { key: "addToFavourite", value: function addToFavourite(


































      newLabel) {var _this = this;
        var mealCopy = angular.copy(this);
        var customMeal = mealCopy.customMeal || _objectSpread({},
        mealCopy, {
          label: newLabel || mealCopy.label,
          id: undefined // later
        });
        this.customMeal = customMeal;

        return $http.get(ApiHttp.miscCustomMeal).
        then(function (res) {return JSON.parse(res.data.value);}).
        catch(function (err) {
          console.warn('get misc error', err);
          if (err.status === 404) {
            return null;
          } else {
            throw err;
          }
        }).
        then(function (res) {
          var customMeals = res || [];
          customMeal.id = (
          customMeals.length ? Math.max.apply(Math, _toConsumableArray(customMeals.map(function (m) {return parseInt(m.id);}))) : 0) +
          1 + '';
          customMeals.push(customMeal);
          ApiFirebase.updateOrCreateUserMeal(
          UserService.data.intercom_id,
          _this);


          var method = res === null ? 'post' : 'put';
          var url = method === 'post' ? ApiHttp.misc : ApiHttp.miscCustomMeal;
          return $http[method](url, {
            key: 'customMeal', value: angular.toJson(customMeals) });

        }).
        then(function (res) {return JSON.parse(res.data.value);}).
        catch(function (err) {console.warn('put misc error', err);throw err;}).
        then(function (updatedCustomMeals) {
          console.log('put custom meal success', updatedCustomMeals);
        });

      } }, { key: "removeFromFavourite", value: function removeFromFavourite()

      {
        var customMeal = this.customMeal;
        this.customMeal = null;

        ApiFirebase.updateUserMeal(
        UserService.data.intercom_id,
        this);


        return $http.get(ApiHttp.miscCustomMeal).
        then(function (res) {return JSON.parse(res.data.value);}).
        catch(function (err) {console.warn('get misc error', err);throw err;}).
        then(function (customMeals) {
          var customMealIndex = customMeals.findIndex(function (m) {return m.id == customMeal.id;});
          customMeals.splice(customMealIndex, 1);
          return $http.put(ApiHttp.miscCustomMeal, {
            key: 'customMeal', value: angular.toJson(customMeals) });

        }).
        then(function (res) {return JSON.parse(res.data.value);}).
        catch(function (err) {console.warn('put misc error', err);throw err;}).
        then(function (updatedCustomMeals) {
          console.log('put custom meal success', updatedCustomMeals);
        });
      } }, { key: "loggedCalories", get: function get() {return this.calculateFact('calories');} }, { key: "loggedProteins", get: function get() {return this.calculateFact('proteins');} }, { key: "loggedFats", get: function get() {return this.calculateFact('fats');} }, { key: "loggedCarbs", get: function get() {return this.calculateFact('carbohydrates');} }, { key: "caloriesPercentage", get: function get() {return this.calculatePercentage('calories');} }, { key: "proteinsPercentage", get: function get() {return this.calculatePercentage('proteins');} }, { key: "fatsPercentage", get: function get() {return this.calculatePercentage('fats');} }, { key: "carbsPercentage", get: function get() {return this.calculatePercentage('carbohydrates');} }], [{ key: "track", value: function track($meal) {return MeasurementSystem.getMeasurementSystem().then(function (measurementSystem) {var loggedMealItems = mapLoggedMealItems($meal.meal_items.filter(function (meal_item) {return !meal_item.deleted;}), measurementSystem);if (!isValidLoggedMealItems(loggedMealItems)) {console.warn(loggedMealItems);Snackbar.error('wrong meal items amount', { timeout: 5000 });return $q.reject('meal items invalid');}return $q.all([loggedMealItems, LoggedMealModel.create({ meal: $meal.id, checkin: UserService.data.last_checkin.id })]);}).then(function (_ref) {var _ref2 = _slicedToArray(_ref, 2),loggedMealItems = _ref2[0],$loggedMeal = _ref2[1];$meal.logged_meal_id = $loggedMeal.id;var _iteratorNormalCompletion = true;var _didIteratorError = false;var _iteratorError = undefined;try {for (var _iterator = loggedMealItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {var loggedMealItem = _step.value;loggedMealItem.logged_meal = $loggedMeal.id;}} catch (err) {_didIteratorError = true;_iteratorError = err;} finally {try {if (!_iteratorNormalCompletion && _iterator.return != null) {_iterator.return();}} finally {if (_didIteratorError) {throw _iteratorError;}}}return LoggedMealItemModel.createMany(loggedMealItems);}).then(function (res) {$meal.logged = true;$meal.skipped = false;ApiFirebase.removeUserMeal(UserService.data.intercom_id, $meal).then(function () {$rootScope.$emit('meal-plan-updated');$rootScope.$emit('show-app-modal');});return res;}).catch(function (err) {console.warn('meal track failed', err);throw err;});} }, { key: "skip", value: function skip($meal) {return LoggedMealModel.create({ meal: $meal.id, checkin: UserService.data.last_checkin.id, skipped: true }).then(function ($loggedMeal) {$meal.logged_meal_id = $loggedMeal.id;$meal.logged = false;$meal.skipped = true;ApiFirebase.removeUserMeal(UserService.data.intercom_id, $meal).then(function () {$rootScope.$emit('meal-plan-updated');$rootScope.$emit('show-app-modal');});return $loggedMeal;}).catch(function (err) {console.warn('meal track failed', err);throw err;});} }, { key: "untrack", value: function untrack($meal) {return LoggedMealModel.delete({ id: $meal.logged_meal_id, logged_meal__meal_id: $meal.id }).then(function (res) {$meal.logged = false;$meal.skipped = false;$meal.logged_meal_id = 0;$meal.logged_meal_items = [];$meal.logged_meal_calories = 0;for (var i = 0; i < $meal.meal_items.length; i++) {$meal.meal_items[i].amount_model = 0;}$rootScope.$emit('meal-plan-updated');return res;}).catch(function (err) {console.warn('$meal untrack error', err);throw err;});} }]);return Meal;}($modelFactory(ApiHttp.userMeals, { defaults: mealDefaults, map: { meal_items: MealItemModel.List, logged_meal_items: LoggedMealItemModel.List, recipe: RecipeModel, image: ImageModel, calories: toFloat, fats: toFloat, proteins: toFloat, carbohydrates: toFloat, recipeMode: function recipeMode(defaultValue, model) {return !!model.recipe && !!model.recipe.id;} } }));



  Meal.List.Model = Meal;

  return Meal;
}



function mapLoggedMealItems() {var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var mesSystem = arguments.length > 1 ? arguments[1] : undefined;
  items = angular.copy(items);
  return items.
  map(function (_ref3) {var id = _ref3.id,meal = _ref3.meal,mealItem = _objectWithoutProperties(_ref3, ["id", "meal"]);
    if (mealItem.amount_model && mealItem.amount_model != 9999) {
      var old_exchange = angular.copy(parseFloat(mealItem.old_exchanges));
      if (mesSystem == 'SI') {
        mealItem.exchanges = mealItem.amount_model / mealItem.portion_si;
        /*mealItem.amount_si = mealItem.amount_model;
                                                                          mealItem.amount = mealItem.exchanges * mealItem.portion;*/
      } else
      {
        mealItem.exchanges = mealItem.amount_model / mealItem.portion;
        /*mealItem.amount = mealItem.amount_model;
                                                                       mealItem.amount_si = mealItem.exchanges * mealItem.portion_si;*/
      }
      mealItem.calories = (mealItem.calories / old_exchange * mealItem.exchanges).toFixed(2) - 0;
      mealItem.fats = (mealItem.fats / old_exchange * mealItem.exchanges).toFixed(2) - 0;
      mealItem.carbohydrates = (mealItem.carbohydrates / old_exchange * mealItem.exchanges).toFixed(2) - 0;
      mealItem.proteins = (mealItem.proteins / old_exchange * mealItem.exchanges).toFixed(2) - 0;
      mealItem.exchanges = mealItem.exchanges.toFixed(2) - 0;
      //mealItem.amount = mealItem.amount.toFixed(2) - 0;
      //mealItem.amount_si = mealItem.amount_si.toFixed(2) - 0;
    } else
    {
      mealItem.amount_model = 9999;
      if (angular.isDefined(mealItem.modal_calories)) {
        mealItem.calories = mealItem.modal_calories;
        mealItem.fats = mealItem.modal_fats;
        mealItem.carbohydrates = mealItem.modal_carbohydrates;
        mealItem.proteins = mealItem.modal_proteins;
        if (mealItem.old_exchanges) {
          mealItem.exchanges = mealItem.old_exchanges.toFixed(2) - 0;
        }
      }
    }
    mealItem.unit = mealItem.unit.substring(0, 32);
    mealItem.unit_si = mealItem.unit_si.substring(0, 32);
    mealItem.groceries_unit = mealItem.groceries_unit.substring(0, 32);
    mealItem.amount = mealItem.amount_si = null;

    return _objectSpread({},
    mealItem, { logged_meal: undefined // later
    });
  });
}


function isValidLoggedMealItems() {var mealItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];var _iteratorNormalCompletion2 = true;var _didIteratorError2 = false;var _iteratorError2 = undefined;try {
    for (var _iterator2 = mealItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {var mealItem = _step2.value;
      if (String(parseInt(mealItem.calories)).length > 4) {return false;}
      if (String(parseInt(mealItem.fats)).length > 4) {return false;}
      if (String(parseInt(mealItem.carbohydrates)).length > 4) {return false;}
      if (String(parseInt(mealItem.proteins)).length > 4) {return false;}
      if (String(parseInt(mealItem.exchanges)).length > 2) {return false;}
    }} catch (err) {_didIteratorError2 = true;_iteratorError2 = err;} finally {try {if (!_iteratorNormalCompletion2 && _iterator2.return != null) {_iterator2.return();}} finally {if (_didIteratorError2) {throw _iteratorError2;}}}
  return true;
}